'use strict';

// Fetch() polyfill for making API calls.
require('whatwg-fetch');



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 1043
// module chunks = 0